<template>
  <SlotContainer v-if="isEdit" refName="slot-sitemapsection" class="owc-footer-sitemap" elementDOM="ul">
    <slot></slot>
  </SlotContainer>
  <ul v-else class="owc-footer-sitemap owc-footer-sitemap--component">
    <OwcFooterSiteMapSection
      v-for="(section, index) in siteMap"
      :key="index"
      :siteMapSection="section"
    ></OwcFooterSiteMapSection>
  </ul>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { SiteMapData, SiteMapMethods, SiteMapComputed, SiteMapProps } from './SiteMap';
import { componentMode } from './Footer.config';
import OwcFooterSiteMapSection from '@owc-packages/Footer/src/SiteMapSection.vue';

/**
 * `SiteMap Footer` - SiteMap for OneWeb - This component contains the sitemap sections for the footer.
 */

export default ComponentInitializeDispatcher.extend<
  SiteMapData,
  SiteMapMethods,
  SiteMapComputed,
  SiteMapProps
>({
  name: 'owc-site-map',
  components: {
    OwcFooterSiteMapSection,
    SlotContainer,
  },
  props: {
    siteMap: {
      type: Array,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
  },
});
</script>

<style lang="scss">
$siteMapModuleName: 'owc-footer-sitemap';

.#{$siteMapModuleName} {
  display: block;
  width: 100%;
  margin-bottom: var(--wb-spacing-l);
  padding-top: var(--wb-spacing-m);

  @include breakpoint-from(mq5) {
    // Since the webcomponents build now use native slots, we have to use the pseudo element ::slotted
    // to reach the classes that are inside of a native slot
    ::slotted(.webcomponent),
    > .webcomponent > .webcomponent {
      @include wb-grid-gaps;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      row-gap: var(--wb-spacing-m);
    }
  }

  &--component {
    @include breakpoint-from(mq5) {
      @include wb-grid-gaps;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      row-gap: var(--wb-spacing-m);
    }
  }
}
</style>
